module.exports = __webpack_public_path__ + "img/title-vi.c2f102e2.png";